import React from 'react';
import PayoutsList from './PayoutsList';

export default function Payouts() {
  return (
    <section className="Payouts">
      <PayoutsList />
    </section>
  );
}
